import { ExportRfidExcel } from "./ExportRfidExcel";
import { ExportRfidPdf } from "./ExportRfidPdf";

export const ExportRfid = ({ rfidData = [] }) => (
  <>
    <ExportRfidExcel rfidData={rfidData} />
    <ExportRfidPdf rfidData={rfidData} />
  </>
);
